import _regeneratorRuntime from "babel-runtime/regenerator";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import MessageBus from "./vanilla/messaging/MessageBus";
import simpleRender from "./vanilla/utils/simpleRender";
import { CommercePlatformContext } from "./CommercePlatformContext";
import { Auth } from "../auth";

export var InvalidFrameStrategyError = function (_Error) {
  _inherits(InvalidFrameStrategyError, _Error);

  function InvalidFrameStrategyError() {
    _classCallCheck(this, InvalidFrameStrategyError);

    return _possibleConstructorReturn(this, _Error.apply(this, arguments));
  }

  return InvalidFrameStrategyError;
}(Error);
export var CouldNotFetchCurrentUserFromIdentityError = function (_Error2) {
  _inherits(CouldNotFetchCurrentUserFromIdentityError, _Error2);

  function CouldNotFetchCurrentUserFromIdentityError() {
    _classCallCheck(this, CouldNotFetchCurrentUserFromIdentityError);

    return _possibleConstructorReturn(this, _Error2.apply(this, arguments));
  }

  return CouldNotFetchCurrentUserFromIdentityError;
}(Error);
export var CouldNotRefreshCurrentUserFromIdentityError = function (_Error3) {
  _inherits(CouldNotRefreshCurrentUserFromIdentityError, _Error3);

  function CouldNotRefreshCurrentUserFromIdentityError() {
    _classCallCheck(this, CouldNotRefreshCurrentUserFromIdentityError);

    return _possibleConstructorReturn(this, _Error3.apply(this, arguments));
  }

  return CouldNotRefreshCurrentUserFromIdentityError;
}(Error);

var IDENTITY_SERVICE_URLS = {
  dev: "https://dev.id.spsc.io",
  test: "https://test.id.spsc.io",
  stage: "https://stage.id.spsc.io",
  prod: "https://id.spsc.io"
};

var AUTH_DOMAINS = {
  dev: "auth.dev.spsapps.net",
  test: "auth.test.spsapps.net",
  prod: "auth.spscommerce.com"
};
var APPLICATION_PREFIX = {
  localhost: "dev"
};

export var AUTH_FLOW_COMMERCE_PLATFORM = "AUTH_FLOW_COMMERCE_PLATFORM";
export var AUTH_FLOW_OAUTH_IMPLICIT = "AUTH_FLOW_OAUTH_IMPLICIT";

var isIframe = function isIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

var getAccessTokenFromStorage = function getAccessTokenFromStorage(authFlow) {
  if (authFlow === AUTH_FLOW_OAUTH_IMPLICIT) {
    return localStorage.getItem("access_token");
  }
  // Legacy location
  return sessionStorage.getItem("token");
};

var stripTrailingSlash = function stripTrailingSlash(str) {
  return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
};

var CommercePlatform = function (_React$Component) {
  _inherits(CommercePlatform, _React$Component);

  function CommercePlatform(props) {
    var _this5 = this;

    _classCallCheck(this, CommercePlatform);

    var _this4 = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this4.getAuthConfig = function (userConfig, env) {
      var defaultConfigDomain = { domain: AUTH_DOMAINS[env] };
      if (userConfig[env] && userConfig[env].clientID) {
        return _extends({}, defaultConfigDomain, userConfig[env]);
      }
      throw new Error("Could not find a clientID entry for the current environment. Please check your authConfig property object.");
    };

    _this4.fetchCurrentUser = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(token) {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!token) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return fetch(_this4.state.identityServiceUrl + "/identity/users/me", {
                  headers: {
                    Authorization: "Bearer " + token
                  }
                });

              case 4:
                response = _context.sent;
                return _context.abrupt("return", response.json());

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                throw new CouldNotFetchCurrentUserFromIdentityError();

              case 11:
                return _context.abrupt("return", null);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[1, 8]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this4.onTokenUpdate = function () {
      _this4.refreshCurrentUser(_this4.props.authFlow);
    };

    _this4.refreshCurrentUser = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authFlow) {
        var accessToken, resp;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.setState({ hasSession: false });
                accessToken = getAccessTokenFromStorage(authFlow);

                if (!accessToken) {
                  _context2.next = 15;
                  break;
                }

                _context2.prev = 3;
                _context2.next = 6;
                return _this4.fetchCurrentUser(accessToken);

              case 6:
                resp = _context2.sent;

                _this4.setState({ token: accessToken, currentUser: resp, hasSession: true }, function () {
                  _this4.setSpinner("hide");
                });
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](3);
                throw new CouldNotRefreshCurrentUserFromIdentityError();

              case 13:
                _context2.next = 16;
                break;

              case 15:
                _this4.setState({ token: null, currentUser: null, hasSession: true }, function () {
                  _this4.setSpinner("hide");
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 10]]);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this4.messageBus = new MessageBus();
    _this4.state = {
      token: null,
      tokenExpiration: null,
      currentUser: null,
      initialRoute: _this4.getPathFromFrameUrl(),
      auth: null,
      environment: null,
      identityServiceUrl: null,
      hasSession: false
    };
    return _this4;
  }

  //TODO: Should we passing this function to the children components instead of the resolved values
  // see line


  CommercePlatform.prototype.getPathFromFrameUrl = function getPathFromFrameUrl() {
    var cpUrlHash = stripTrailingSlash(window.location.hash.substr(1));

    if (!cpUrlHash || cpUrlHash.length === 0 || cpUrlHash === "/") {
      // Sadly a default path is required due to iframe constraints
      // where the iframe will always load your app's slash/root
      // route even if that isn't at all where users will eventually
      // be routed.
      var indexPath = this.props.indexPath || "/home";

      this.messageBus.send("appStateChange", {
        path: indexPath
      });
      return indexPath;
    }
    return cpUrlHash;
  };

  CommercePlatform.prototype.setSpinner = function setSpinner(newState) {
    var frameStrategy = this.props.frameStrategy;

    if (frameStrategy === "iframe") {
      if (newState === "hide") {
        this.messageBus.send("spinnerHide");
      }
      // do we need to check for 'show'? It appears it isn't currently being used in this file.
      if (newState === "show") {
        this.messageBus.send("spinnerShow");
      }
    }
  };

  CommercePlatform.prototype.fetchCurrentEnvironment = function fetchCurrentEnvironment() {
    var _this6 = this;

    var frameStrategy = this.props.frameStrategy;

    if (frameStrategy === "iframe") {
      return new Promise(function (resolve) {
        _this6.messageBus.send("getEnvironment").onResponse(function (env) {
          resolve(env);
        });
      });
    }
    if (frameStrategy === "stand-alone") {
      var environmentMap = this.props.environmentMap;

      return new Promise(function (resolve) {
        resolve(environmentMap[window.location.hostname]);
      });
    }
  };

  CommercePlatform.prototype.redirectLocalhostToCommercePlatformIframe = function redirectLocalhostToCommercePlatformIframe() {
    var openToUrl = this.props.openToUrl;

    if (!isIframe()) {
      if (!!openToUrl) {
        if (openToUrl != null && openToUrl != "null") {
          document.location.replace(openToUrl);
        }
      } else {
        console.warn("You should consider adding an openToUrl prop to your <CommercePlatform> component. openToUrl helps new local developers by redirecting them to your application inside the CommercePlatform iframe. This prop should match your app's dev center url in the dev environment. If you have not yet created your app in Dev Center then you will want to do that in order to ensure that it works properly before going to production.");
      }
    }
  };

  CommercePlatform.prototype.checkFrameStrategy = function checkFrameStrategy(frameStrategy) {
    if (!frameStrategy || frameStrategy !== "iframe" && frameStrategy !== "stand-alone") {
      throw new InvalidFrameStrategyError("Please set the <CommercePlatform> component's frameStrategy prop to the string 'iframe' or 'stand-alone'. These are the only currently supported frame strategies for this component.");
    }
  };

  CommercePlatform.prototype.componentDidMount = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _this7 = this;

      var auth, _props, authConfig, frameStrategy, onAuthRedirect, envResp, identityUrl;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              auth = null;
              _props = this.props, authConfig = _props.authConfig, frameStrategy = _props.frameStrategy, onAuthRedirect = _props.onAuthRedirect;


              if (frameStrategy === "iframe") {
                this.redirectLocalhostToCommercePlatformIframe();
              }

              this.checkFrameStrategy(frameStrategy);
              _context3.next = 6;
              return this.fetchCurrentEnvironment();

            case 6:
              envResp = _context3.sent;

              if (frameStrategy === "stand-alone") {
                auth = new Auth(this.getAuthConfig(authConfig, envResp), this.onTokenUpdate);
              }
              identityUrl = IDENTITY_SERVICE_URLS[envResp];

              if (identityUrl) {
                _context3.next = 11;
                break;
              }

              throw new Error("Identity service environment could not be defined");

            case 11:
              this.setState({ environment: envResp, identityServiceUrl: identityUrl, auth: auth }, function () {
                if (auth && auth != null) {
                  var _auth;

                  (_auth = auth).handleAuthentication.apply(_auth, onAuthRedirect);
                }
                _this7.refreshCurrentUser(_this7.props.authFlow);
              });

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function componentDidMount() {
      return _ref3.apply(this, arguments);
    }

    return componentDidMount;
  }();

  CommercePlatform.prototype.render = function render() {
    // This object is passed down into child components
    // and represents the commerce platform api
    var commercePlatform = {
      authFlow: this.props.authFlow,
      token: this.state.token,
      currentUser: this.state.currentUser,
      initialRoute: this.state.initialRoute,
      environment: this.state.environment,
      auth: this.state.auth,
      identityServiceUrl: this.state.identityServiceUrl,
      refreshCurrentUser: this.refreshCurrentUser,
      hasSession: this.state.hasSession,
      isIframe: isIframe()
    };
    // setAccessToken,
    // getCurrentUser,
    // setTitle,
    // setUrl

    // This allows for either RENDER PROP or FUNCTION AS CHILD
    // to be used.
    return simpleRender(this.props, function (render) {
      return React.createElement(
        CommercePlatformContext.Provider,
        { value: commercePlatform },
        render(commercePlatform)
      );
    }, function () {
      throw Error("You must place an application inside of the <CommercePlatform> component as either a render prop, function as child, or child component.");
    });
  };

  return CommercePlatform;
}(React.Component);

export { CommercePlatform as default };
CommercePlatform.propTypes = process.env.NODE_ENV !== "production" ? {
  frameStrategy: PropTypes.oneOf(["stand-alone", "iframe"]).isRequired,
  openToUrl: PropTypes.string,
  authFlow: PropTypes.oneOf([AUTH_FLOW_OAUTH_IMPLICIT, AUTH_FLOW_COMMERCE_PLATFORM]).isRequired,
  environmentMap: function environmentMap(props, propName, componentName) {
    if (props["frameStrategy"] === "stand-alone" && (props[propName] === undefined || _typeof(props[propName]) !== "object")) {
      return new Error("Please provide an environmentMap object when using the 'stand-alone' frame strategy!");
    }
  }
} : {};